import React from "react";

export default function () {
    return (
        <React.Fragment>
            <p>&nbsp;</p>
            <h1>Welcome to The Write Class&trade;!</h1>
            <p>
                The Write Class&trade; is an online first-year writing course
                placement tool that integrates various points of data to create
                a personalized course placement for each student. It integrates
                and analyzes each student's
            </p>
            <ul>
                <li>standardized test scores;</li>
                <li>high school GPA (if applicable);</li>
                <li>writing and reading history;</li>
                <li>preparedness for each course.</li>
            </ul>
            <p>
                It does not allow for multiple attempts, and placement results
                are final. Based on the information you provide in The Write
                Class&trade;, you will be placed into ENGL 100/101A, 101, or have the
                opportunity to submit a portfolio for ENGL 102.
            </p>
            <p>
                This process will take between 20-30 minutes. Please be sure you
                have the time to answer all questions before beginning.
            </p>
            <p>
                If you believe you already have credits for one or more of the
                courses listed above, you will receive more detailed information
                about your options at the end of this process.
            </p>
            <p>
                <b>Honor Code Agreement</b>
            </p>
            <p>
                As a member of the College of Southern Idaho community, you are
                obligated to abide by College of Southern Idaho’s&nbsp;
                <a
                    href="https://quondam.csi.edu/studentHandbook/index.asp"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Student Code of Conduct
                </a>
                .
            </p>
        </React.Fragment>
    );
}



// WEBPACK FOOTER //
// ./src/siteConfig/sites/csi/siteComponents/auth.js